import { FC, ReactNode } from "react";
import {
  CancellationDestination,
  CancellationInclude,
  ICancellationPreview
} from "../../../interfaces/reservations/Cancellation.types";
import { cx } from "../../../utils/classnames";
import { eur } from "../../../utils/eur";
import { addOnValue, IIncludeItem, isIncluded } from "../../../utils/reservations/cancellation";
import InfoTip from "./InfoTip";

const DESTINATIONS: { key: CancellationDestination; label: string; tip: string }[] = [
  {
    key: "OriginalPayment",
    label: "Në kartelën e klientit",
    tip: "Paraja kthehet në kartelën me të cilën u pagua."
  },
  {
    key: "GjirafaMoney",
    label: "Gjirafa Money",
    tip: "Kthehet menjëherë, pa shërbimet që klienti ende i përdor (eSIM). Nuk kthehet në para."
  }
];

export const Choice: FC<{ type: "radio" | "checkbox"; checked: boolean; onChange: () => void;
  label: string; tip?: string; aside?: ReactNode; name?: string; }> = ({
  type, checked, onChange, label, tip, aside, name
}) => (
  <label
    className={cx([
      "flex items-center gap-2 rounded-md border px-3 py-2 cursor-pointer",
      checked ? "border-gray-400 bg-white" : "border-gray-200"
    ])}
  >
    <input type={type} name={name} className="w-4 h-4 border-gray-300 rounded"
      checked={checked} onChange={onChange} />
    <span className="flex-1 min-w-0 text-sm text-black">{label}</span>
    {tip && <InfoTip text={tip} />}
    {aside !== undefined && <span className="text-xs tabular-nums text-gray-600">{aside}</span>}
  </label>
);

export const Section: FC<{ title: string; children: ReactNode }> = ({ title, children }) => (
  <section className="flex flex-col gap-2">
    <h3 className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">{title}</h3>
    {children}
  </section>
);

const CancellationOptions: FC<{
  items: IIncludeItem[];
  overrides: CancellationInclude;
  preview: ICancellationPreview | null;
  onToggle: (item: IIncludeItem, next: boolean) => void;
  destination: CancellationDestination;
  onDestination: (next: CancellationDestination) => void;
  refund: boolean;
  onRefund: (next: boolean) => void;
}> = (p) => (
  <>
    <Section title="Çfarë kthehet">
      <Choice type="checkbox" label="Pa rimbursim"
        tip="Biletat anulohen dhe klientit nuk i kthehet asgjë."
        checked={!p.refund} onChange={() => p.onRefund(!p.refund)} />
      {p.refund && p.items.length > 0 && (
        <div className="grid grid-cols-2 gap-1">
          {p.items.map((item) => {
            const checked = isIncluded(item, p.overrides, p.preview);
            const value = addOnValue(item, p.preview);
            return (
              <Choice key={item.key} type="checkbox" label={item.label} checked={checked}
                aside={value === null ? undefined : `+${eur(value)}`}
                onChange={() => p.onToggle(item, !checked)} />
            );
          })}
        </div>
      )}
    </Section>
    {p.refund && (
      <Section title="Ku kthehet paraja">
        {DESTINATIONS.map((option) => (
          <Choice key={option.key} type="radio" name="cancellation-destination" label={option.label}
            tip={option.tip} checked={p.destination === option.key}
            onChange={() => p.onDestination(option.key)} />
        ))}
      </Section>
    )}
  </>
);

export default CancellationOptions;
